import React from 'react';
import { Link } from 'react-router-dom';
import { useActivitiesHeaderStyles } from './DropDownHeader.style';

type Props = { options: { label: string; link?: string }[]; children: React.ReactNode };

export const DropDownHeader = ({ options, children }: Props) => {
  const styles = useActivitiesHeaderStyles();

  return options?.length > 0 ? (
    <div className={styles.dropdownElement}>
      {children}
      <ul id="dropdownContainer" className={styles.dropdownContainer}>
        {options?.map((option, index) => (
          <li className={styles.dropdownItem} key={index}>
            {option.link ? <Link to={option.link}>{option.label}</Link> : option.label}
          </li>
        ))}
      </ul>
    </div>
  ) : null;
};
